/**
 * Banner buttons with data-ylty-account="login" | "register" open the theme's
 * own account drawer on the Inloggen or Registreren view.
 *
 * It picks the view the way header.js does (d-none on .login-popup /
 * .reg-popup) and then clicks the header's account icon, so the theme's own
 * opening logic (body.open-account-popup, scrollbar compensation) runs as
 * usual. Without the drawer (logged in, or the login page, where the theme
 * does not render it) the button falls back to its href.
 */
(() => {
  if (window.yltyAccountButtons) return; // several banners can load this file
  window.yltyAccountButtons = true;

  const openDrawer = (view) => {
    const drawer = document.querySelector('.main-acc-popup');
    const trigger = document.querySelector('.header-icons li.userlist.click');
    if (!drawer || !trigger) return false;

    const login = drawer.querySelector('.login-popup');
    const register = drawer.querySelector('.reg-popup');
    if (login && register) {
      login.classList.toggle('d-none', view !== 'login');
      register.classList.toggle('d-none', view !== 'register');
    }
    // header.js toggles, so only click when the drawer is closed.
    if (!document.body.classList.contains('open-account-popup')) trigger.click();
    return true;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ylty-account]');
    if (!button) return;
    if (openDrawer(button.getAttribute('data-ylty-account'))) event.preventDefault();
  });
})();
